import React from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";

function Copyright() {
	return (
		<Typography variant="body2" className="text-white">
			{"Copyright © "}
			SGIO {new Date().getFullYear()}
			{"."}
		</Typography>
	);
}

const Footer = () => {
	return (
		<Box
			component="footer"
			sx={{
				py: 2,
				px: 2,
				mt: "auto",
				backgroundColor: "#2B55B2",
			}}
		>
			<Container maxWidth="sm" className="text-center ">
				<Copyright />
			</Container>
		</Box> 
	);
};

export default Footer;
